import request from '../../axios';

export const postLoanValidationRequest = async (loanRequestGuid: string) => {
  const data = await request.post(`/api/v2/payment/loan-validation-request`, {
    loan_request: loanRequestGuid,
  });

  return data;
};
